<script context="module" lang="ts">
    export enum Direction {
        RIGHT,
        DOWN,
    }
</script>

<script lang="ts">
    export let posX: number;
    export let posY: number;

    export let direction: Direction;

    export let simValue = false;

    $: rotate = direction === Direction.DOWN
        ? "rotate(90 0 0)"
        : "";
</script>

<g transform={"translate(" + posX + " " + posY + ") " + rotate}>
    <polygon 
        points="1,0 4,3 26,3 29,0 26,-3 4,-3"
        class:simValueTrue={simValue}
        class:simValueFalse={!simValue} >

    </polygon>
</g>

<style>
    .simValueTrue {
        fill: red;
    }

    .simValueFalse {
        fill: #b5b5b5;
    }
</style>